import { useState, useEffect } from 'preact/compat';

export function useFileUrl(file: File): string | null {
    const [url, setUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!file.type.startsWith('image/')) {
            return;
        }

        setUrl(URL.createObjectURL(file));
    }, [file]);

    return url;
}
